
export const Events = {

  MARK_FOR_FIX: 'charizard-mark-for-fix',
  REPLACE_BLOCK: 'charizard-replace-block',
  SHOW_MARK_TO_FIX: 'charizard-show-mark-to-fix',
  DROP_BLOCK: 'charizard-drop-block',
  
  INSERT_CONTENT: 'charizard-insert-content',
  SET_CONTENT: 'charizard-set-content',
  SELECTION: 'charizard-selection',
  SCROLL: 'charizard-scroll',
  AWARENESS: 'charizard-awareness',
  TOAST: 'charizard-toast',
  PRIME_CONTEXT: 'charizard-prime-context',
  CLEAR_DOPDOWNS: 'charizard-clear-dropdowns',

  CHAT_QUESTION: 'charizard-chat-question',
  UPDATE_DOCUMENT: 'charizard-update-document',

  listen(name: string, cb: (e: CustomEvent) => any) {
    window.addEventListener(name, cb);    
    currentGroup.add(name, cb);
    
    return (payload) => cb(customEvent(name, payload));
  },

  dispatch(name: string, payload) {
    window.dispatchEvent(new CustomEvent(name, {
      detail: payload 
    }));
  },

  group() {
    try {
      return currentGroup;
    } finally {
      currentGroup = new EventGroup()
    }
    
  }
}


export class EventGroup {

  listeners = []

  add(name, cb) {
    this.listeners.push({
      name, cb
    })
  }

  dispose = () => {
    this.listeners.forEach(({name, cb}) => {
      try {
        window.removeEventListener(name, cb)
      } catch(e) {
        console.error(e)
      }
    })
  }
}

const customEvent = (name, payload) => new CustomEvent(name, {
  detail: payload 
});

let currentGroup = new EventGroup()

